module.exports = __webpack_public_path__ + "static/media/logo_white.5339c7f0.svg";